var React = require('react');

function Pin (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10.9995 6c-.0406-3.05013-2.33712-5-4.99979-5-2.66266 0-4.95864 1.94987-4.9992 5-.035599 2.67719 1.78567 6.202 4.9992 10 3.21352-3.798 5.03539-7.32281 4.99979-10z","stroke":"currentColor","key":0}),React.createElement("circle",{"cx":"6","cy":"6","r":"2","stroke":"currentColor","key":1})]);
}

Pin.defaultProps = {"viewBox":"0 0 12 17","fill":"none"};

module.exports = Pin;

Pin.default = Pin;
